import React from "react";

import styled, { keyframes } from "styled-components";

const pulseAnimation = keyframes`
  0% {
   opacity: 1
  }

  50% {
    opacity: 0.5
  }

  100% {
    opacity: 1
  }
`;

const SVG = styled.svg`
  animation: ${pulseAnimation} 1.25s infinite;
  fill: var(--fd-colors-content-loading-default, rgba(10, 10, 10, 0.05));
  max-width: 300px;
`;

const Container = styled.div`
  background-color: var(--fd-colors-background-surface);
`;

export default function PageTitleLoading() {
  return (
    <Container>
      <SVG
        width="100%"
        preserveAspectRatio="none"
        height="35"
        viewBox="0 0 300 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="300" height="35" rx="2" />
      </SVG>
    </Container>
  );
}
